module.exports = __webpack_public_path__ + "img/sf_thumb.be5e7193.jpg";